import { useState, useEffect } from "react";
import { apiClient } from "../../utils/api";

interface UseAgentCategoriesReturn {
  categories: string[];
  isLoading: boolean;
  error: string;
  refresh: () => Promise<void>;
}

const useAgentCategories = (): UseAgentCategoriesReturn => {
  const [categories, setCategories] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchCategories = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.get("/api/v1/agent/categories");
      const responseData: string[] = response.data;

      if (Array.isArray(responseData)) {
        setCategories(responseData);
      } else {
        setError("카테고리 데이터 형식이 올바르지 않습니다.");
      }
    } catch (err) {
      console.error("카테고리 목록 조회 오류:", err);
      setError("카테고리를 불러오는데 실패했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const refresh = async () => {
    await fetchCategories();
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    isLoading,
    error,
    refresh,
  };
};

export default useAgentCategories;
export type { UseAgentCategoriesReturn }; 